(function () {
  if (!document.body.classList.contains('template-index')) return;

  var root = document.querySelector('.index-sections');
  if (!root) return;

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var revealObserver = null;
  var REVEAL_DELAY_MS = 250;
  var REVEAL_DEPTH_RATIO = 0.06;
  var childrenOnlySections = [
    'homepage-section--feature-highlights-wrapper',
    'homepage-section--new-arrivals-wrapper',
    'split-image-banner-section',
    'homepage-section--celebrations-carousel-wrapper',
    'homepage-section--sweet-collections-wrapper',
    'homepage-section--sweet-showcase-wrapper',
    'homepage-section--image'
  ];

  function clearRevealTimer(section) {
    var timerId = section.dataset.indexRevealTimer;
    if (timerId) {
      window.clearTimeout(Number(timerId));
      delete section.dataset.indexRevealTimer;
    }
  }

  function revealSection(section) {
    clearRevealTimer(section);
    section.classList.add('is-index-revealed');
    if (revealObserver) revealObserver.unobserve(section);
  }

  function hasScrolledIntoSection(entry) {
    var rect = entry.boundingClientRect;
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    var revealLine = viewportHeight * (1 - REVEAL_DEPTH_RATIO);

    return rect.top <= revealLine && entry.intersectionRatio >= 0.12;
  }

  function scheduleReveal(section) {
    if (section.classList.contains('is-index-revealed') || section.dataset.indexRevealTimer) return;

    section.dataset.indexRevealTimer = String(
      window.setTimeout(function () {
        delete section.dataset.indexRevealTimer;
        revealSection(section);
      }, REVEAL_DELAY_MS)
    );
  }

  function usesChildAnimation(section) {
    return childrenOnlySections.some(function (className) {
      return section.classList.contains(className);
    });
  }

  function prepareSection(section, index) {
    if (section.classList.contains('index-animate')) return;

    section.classList.add('index-animate');

    if (index === 0) {
      section.classList.add('index-animate--hero');
    } else if (usesChildAnimation(section)) {
      section.classList.add('index-animate--children-only');
    }

    if (prefersReduced) {
      revealSection(section);
    }
  }

  function init() {
    var sections = root.querySelectorAll(':scope > .shopify-section');
    if (!sections.length) return;

    sections.forEach(function (section, index) {
      prepareSection(section, index);
    });

    if (prefersReduced) return;

    var hero = sections[0];
    if (hero) {
      requestAnimationFrame(function () {
        revealSection(hero);
      });
    }

    revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && hasScrolledIntoSection(entry)) {
            scheduleReveal(entry.target);
          }
        });
      },
      {
        threshold: [0, 0.12, 0.2, 0.35],
        rootMargin: '0px 0px -18% 0px'
      }
    );

    sections.forEach(function (section, index) {
      if (index > 0 && !section.classList.contains('is-index-revealed')) {
        revealObserver.observe(section);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.detail || !event.detail.sectionId) return;

    var section = document.getElementById('shopify-section-' + event.detail.sectionId);
    if (!section || !root.contains(section)) return;

    var sections = root.querySelectorAll(':scope > .shopify-section');
    var index = Array.prototype.indexOf.call(sections, section);

    prepareSection(section, index === -1 ? 1 : index);

    if (!prefersReduced && revealObserver && !section.classList.contains('is-index-revealed')) {
      if (index === 0) {
        requestAnimationFrame(function () {
          revealSection(section);
        });
      } else {
        revealObserver.observe(section);
      }
    }
  });
})();
